// eslint-disable-next-line import/no-cycle
import ActiveSubscriptionWithShipment from './components/ActiveSubscriptionWithShipment';
import ActiveTraditionalWithShipment from './components/ActiveTraditionalWithShipment';

const ClubMembershipDisplay = (props) => {
  const { clubMembership } = props;
  if (clubMembership.status === 'Cancelled') {
    return null;
  }
  // Subscription Clubs
  if (clubMembership.clubType === 'Subscription') {
    if (!clubMembership.activeClubSubscriptionShipmentId) {
      return null;
    }
    return (
      <ActiveSubscriptionWithShipment
        clubMembership={clubMembership}
        router="noRouter"
      />
    );
  }
  // Traditional Clubs
  if (
    !clubMembership.activeClubPackageId ||
    !clubMembership.activeClubMemberShipmentId
  ) {
    return null;
  }
  return (
    <ActiveTraditionalWithShipment
      clubMembership={clubMembership}
      router="noRouter"
    />
  );
};

export default ClubMembershipDisplay;
